import React from "react";
import { useBluelagoon } from "@bluelagoon";
import CreateDatabaseOrTableModal from "../CreateDatabaseOrTableModal";
import CloneDatabaseModal from "../CloneDatabaseModal";
import DeleteConfirmationModal from "../DeleteConfirmationModal";

export default function useDatabaseActions(refreshDatabases) {
    const [modalMode, setModalMode] = React.useState("database");
    const [selectedDatabase, setSelectedDatabase] = React.useState(null);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isCloneModalOpen, setIsCloneModalOpen] = React.useState(false);
    const [databaseToClone, setDatabaseToClone] = React.useState(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);
    const [itemToDelete, setItemToDelete] = React.useState(null);
    const [isDeleting, setIsDeleting] = React.useState(false);

    const { call: deleteDatabaseCall } = useBluelagoon({ method: "deleteDatabase" });
    const { call: deleteTableCall } = useBluelagoon({ method: "deleteTable" });

    const openDatabaseModal = () => {
        setModalMode("database");
        setSelectedDatabase(null);
        setIsModalOpen(true);
    };

    const openTableModal = (database) => {
        setModalMode("table");
        setSelectedDatabase(database);
        setIsModalOpen(true);
    };

    const openCloneModal = (database) => {
        setDatabaseToClone(database);
        setIsCloneModalOpen(true);
    };

    const openDeleteModal = (item, type) => {
        setItemToDelete({ ...item, type });
        setIsDeleteModalOpen(true);
    };

    const handleDatabaseCreated = () => {
        refreshDatabases();
        setIsModalOpen(false);
        setModalMode("database");
        setSelectedDatabase(null);
    };

    const handleDatabaseCloned = () => {
        refreshDatabases();
        setIsCloneModalOpen(false);
        setDatabaseToClone(null);
    };

    const handleDelete = async (confirmationWord) => {
        if (!itemToDelete) return;
        setIsDeleting(true);
        try {
            if (itemToDelete.type === "database") {
                await deleteDatabaseCall({ databaseId: itemToDelete.id, confirmationWord });
            } else {
                await deleteTableCall({ tableId: itemToDelete.id, confirmationWord });
            }
            refreshDatabases();
            setIsDeleteModalOpen(false);
            setItemToDelete(null);
        } catch (error) {
            console.error("Failed to delete:", error);
        } finally {
            setIsDeleting(false);
        }
    };

    const Modals = ({ isAdmin }) => (
        <>
            <CreateDatabaseOrTableModal
                mode={modalMode}
                databaseId={selectedDatabase?.id}
                databaseName={selectedDatabase?.name}
                onSuccess={handleDatabaseCreated}
                open={isModalOpen}
                onOpenChange={setIsModalOpen}
            />
            <CloneDatabaseModal
                databaseToClone={databaseToClone}
                onSuccess={handleDatabaseCloned}
                open={isCloneModalOpen}
                onOpenChange={setIsCloneModalOpen}
            />
            <DeleteConfirmationModal
                open={isDeleteModalOpen}
                onOpenChange={setIsDeleteModalOpen}
                onConfirm={handleDelete}
                itemType={itemToDelete?.type}
                itemName={itemToDelete?.name}
                isDeleting={isDeleting}
                isAdmin={isAdmin}
            />
        </>
    );

    return {
        openDatabaseModal,
        openTableModal,
        openCloneModal,
        openDeleteModal,
        Modals,
    };
}
